module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="tab-forms tab-search-hot-tours">\n    <span class="tab-forms__hot-icon"></span>\n    <span class="tab-select-container">Горящие туры </span>\n    <span class="tab-search-hot-tours-discount">-50%</span>\n</div>';
}
return __p;
};
